export const DefaultAvatar = '/static/media/defaultavatar.02624da3.png';